export default function Manage(state = { managestate: (localStorage.getItem("manage") ? (localStorage.getItem("manage")) : "")}, action) {
    switch (action.type) {
        case 'MANAGE_STATE':
            return {
                managestate: action.managestate
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducer/managesignin.jsx